export const CURRENT_CLIENT_PATRONAGE_HINTS = 'currentClientPatronageHints';
